import { useState } from "react";
import { Plus } from "lucide-react";

const TABS = [
  { id: "simples", label: "En palabras simples" },
  { id: "datos", label: "Datos de campo" },
  { id: "specs", label: "Especificaciones técnicas" },
];

// Las tres pestañas de cada dron: «En palabras simples» (abierta por defecto),
// «Datos de campo» y «Especificaciones técnicas». Se ve una a la vez.
export default function DroneTabs({ drone }) {
  const [tab, setTab] = useState("simples");

  return (
    <div data-testid={`drone-tabs-${drone.slug}`} className="border border-hud bg-ink">
      <div role="tablist" aria-label={`Información del ${drone.modelo}`} className="flex overflow-x-auto border-b border-hud">
        {TABS.map((t) => (
          <button
            key={t.id}
            role="tab"
            data-testid={`drone-tab-${drone.slug}-${t.id}`}
            aria-selected={tab === t.id}
            onClick={() => setTab(t.id)}
            className={`whitespace-nowrap px-5 py-4 font-mono text-[10px] uppercase tracking-[0.18em] transition-colors duration-300 sm:px-7 sm:text-[11px] ${
              tab === t.id
                ? "border-b-2 border-certero bg-surface text-certero"
                : "text-mist/60 hover:text-certero"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="p-7 sm:p-8" role="tabpanel" data-testid={`drone-panel-${drone.slug}-${tab}`}>
        {tab === "simples" && (
          <ul className="flex flex-col gap-3">
            {drone.simples.map((s) => (
              <li key={s} className="flex items-start gap-3 text-sm leading-relaxed text-mist/85">
                <Plus className="mt-0.5 h-3.5 w-3.5 shrink-0 text-certero" strokeWidth={2} />
                {s}
              </li>
            ))}
          </ul>
        )}

        {tab === "datos" && (
          <div data-testid={`drone-datos-campo-${drone.slug}`}>
            <p className="text-xs leading-relaxed text-smoke">
              Respuestas oficiales de CERTERO sobre su propia operación en campo.
            </p>
            <div className="mt-5 flex flex-col gap-3.5">
              {drone.datosCampo.map(({ q, a }) => (
                <div key={q} className="border-b border-hud/60 pb-3.5 last:border-0">
                  <p className="text-sm text-mist/85">{q}</p>
                  <p className="mt-1 font-mono text-xs text-certero" data-testid="dato-campo-respuesta">{a}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {tab === "specs" && (
          <dl>
            {drone.specs.map(([l, v]) => (
              <div key={l} className="flex items-baseline justify-between gap-6 border-b border-hud/50 py-2.5 last:border-0">
                <dt className="font-mono text-[10px] uppercase tracking-[0.12em] text-smoke sm:text-[11px]">{l}</dt>
                <dd className="text-right font-mono text-xs text-mist sm:text-sm">{v}</dd>
              </div>
            ))}
          </dl>
        )}
      </div>
    </div>
  );
}
